import { type Reader, readerFromClaims } from "@/lib/reader";
import { createClient } from "@/lib/supabase/client";

export function subscribeToReader(
  onReader: (reader: Reader | undefined) => void
) {
  const supabase = createClient();
  let generation = 0;
  let currentId: string | null | undefined;
  let timeout: ReturnType<typeof setTimeout> | undefined;
  const { data } = supabase.auth.onAuthStateChange((_event, session) => {
    const version = ++generation;
    clearTimeout(timeout);
    if (!session) {
      currentId = null;
      onReader(readerFromClaims(null));
      return;
    }
    if (currentId !== session.user.id) {
      onReader(undefined);
    }
    // Supabase holds its auth lock during the callback. Verify outside it,
    // using the event's token so a later session cannot race this read.
    timeout = setTimeout(async () => {
      let reader: Reader;
      try {
        const { data: claims } = await supabase.auth.getClaims(
          session.access_token
        );
        reader = readerFromClaims(claims?.claims);
      } catch {
        reader = readerFromClaims(null);
      }
      if (generation === version) {
        currentId = reader.id;
        onReader(reader);
      }
    }, 0);
  });
  return () => {
    generation++;
    clearTimeout(timeout);
    data.subscription.unsubscribe();
  };
}
